import { takeLatest, call, put, select } from 'redux-saga/effects'

// Helper for api errors
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'
import EnvConfig from '../../../config/env'

// Our login constants
import {
  REGISTER_REQUESTING,
  REGISTER_SUCCESS,
  REGISTER_ERROR,
  REGISTER_URL,
} from './constants'

const getRegisterState = state => state.register;
const registerUrl = EnvConfig.REACT_APP_API_URL + REGISTER_URL

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function registerApi (formData) {
  const request = axiosApi().post(registerUrl, formData);
  return handleRequest(request);
}

function* registerFlow () {
  const register = yield select(getRegisterState);
  try {
    // will pause here until we either are successful or
    // receive an error
    const {code, message} = yield call(registerApi, register.postData)
    if (code != 200){
      yield put({ type: REGISTER_ERROR, error: message })
    }
    else {
      // .. also inform redux that our login was successful
      yield put({ type: REGISTER_SUCCESS, message: message })
    }
  } catch (error) {
    // error? send it to redux
    yield put({ type: REGISTER_ERROR, error })
  }
}

// Our watcher (saga).  It will watch for many things.
function* requestWatcher () {
  yield takeLatest(REGISTER_REQUESTING, registerFlow)
}

export default requestWatcher



// WEBPACK FOOTER //
// ./src/views/Pages/Register/sagas.js